// extracted by mini-css-extract-plugin
export var content = "article-sign-up-embed-module--content--7a7f7";
export var header = "article-sign-up-embed-module--header--9f06f";
export var icon = "article-sign-up-embed-module--icon--dc26e";
export var root = "article-sign-up-embed-module--root--091bb";
export var tfk = "article-sign-up-embed-module--tfk--17326";
export var tfk__image = "article-sign-up-embed-module--tfk__image--966ef";